/**
 * Scoring base: suma de ítems (inversos donde aplique).
 * Por ahora solo mock: suma de valores para MOCK_TEST_ID.
 */
export function scoreMockPersonality(answers: Record<string, number>): number {
  return Object.values(answers).reduce((s, v) => s + (typeof v === 'number' ? v : 0), 0);
}

export function getBand(score: number, min: number, max: number): 'low' | 'medium' | 'high' {
  const range = max - min;
  const third = range / 3;
  if (score <= min + third) return 'low';
  if (score >= max - third) return 'high';
  return 'medium';
}
